export default "__VITE_ASSET__0a648e07__"